export default "__VITE_ASSET__H_7igIBo__";